module.exports = __webpack_public_path__ + "static/media/database.0547866e.svg";